import withFormikWrapper from '../formik/withFormikWrapper';
import CleanZipInput from '../cleanZipInput';

export const CleanFormikZipInput = withFormikWrapper()(CleanZipInput);
